import apiFetch from '../apiFetch'

export default function (list, token) {
  return apiFetch({endPoint: `Pool/eliminarPoolSeleccion`, method: 'POST', body: {list}, token: token})
}